import { today } from "@/lib/format";
import { X } from "lucide-react";

const firstOfMonth = () => today().slice(0, 8) + "01";

export const rangeParams = (range) => {
  const p = {};
  if (range.from) p.from_date = range.from;
  if (range.to) p.to_date = range.to;
  return p;
};

export default function DateRangeBar({ range, onChange, testid = "range", children }) {
  const preset = (id) => {
    if (id === "today") onChange({ from: today(), to: today() });
    else if (id === "month") onChange({ from: firstOfMonth(), to: today() });
    else onChange({ from: "", to: "" });
  };
  return (
    <div className="no-print bg-white border border-slate-200 rounded-md p-3 flex flex-wrap items-end gap-3" data-testid={`${testid}-bar`}>
      <div><label className="text-[11px] uppercase tracking-wider font-semibold text-slate-500">From</label>
        <input data-testid={`${testid}-from`} type="date" value={range.from} onChange={(e)=>onChange({...range, from:e.target.value})} className="mt-1 block h-9 px-2 border border-slate-300 rounded text-sm mono outline-none focus:border-blue-600"/></div>
      <div><label className="text-[11px] uppercase tracking-wider font-semibold text-slate-500">To</label>
        <input data-testid={`${testid}-to`} type="date" value={range.to} onChange={(e)=>onChange({...range, to:e.target.value})} className="mt-1 block h-9 px-2 border border-slate-300 rounded text-sm mono outline-none focus:border-blue-600"/></div>
      <div className="flex gap-1">
        {[["today","Today"],["month","This Month"],["all","All"]].map(([id,l]) => (
          <button key={id} data-testid={`${testid}-preset-${id}`} onClick={()=>preset(id)} className="h-9 px-3 border border-slate-300 rounded-md text-xs font-semibold uppercase tracking-wider bg-white hover:bg-slate-50">{l}</button>
        ))}
        {(range.from||range.to) && <button data-testid={`${testid}-clear`} onClick={()=>preset("all")} className="h-9 px-2 text-slate-400 hover:text-slate-900" title="Clear dates"><X size={14}/></button>}
      </div>
      <div className="flex-1"/>
      {children}
    </div>
  );
}
